// *******************************************************************************
// Parallax Module
// *******************************************************************************

const parallaxModule = document.querySelectorAll('.parallax-module');

if (parallaxModule.length > 0) {
  let parallaxModuleImage = null;

  const initParallaxScrollMagic = () => {
    parallaxModuleImage = new ScrollMagic.Controller();

    parallaxModule.forEach((element) => {
      const parentElem = element.closest('.sc-parallax-module');
      const bottomSpace = parentElem.querySelector('.parallax-module__fake-spacing');
      const headerEle = parentElem.querySelector('.parallax-module__inner');
      const stickyElem = parentElem.querySelector('.parallax-module__sticky');
      const wrapperEle = parentElem.querySelector('.parallax-module__image-list-wrapper');
      const allImages = wrapperEle.querySelectorAll('.parallax-module__image');

      // Bottom space for unpin title
      const bottomSpaceHeight = bottomSpace?.clientHeight ?? 212;
      const totalScrollDuration = wrapperEle.clientHeight - headerEle.clientHeight;
      const totalStickyDuration = wrapperEle.clientHeight - bottomSpaceHeight;
      const totalDuration = windowWidth() > breakpointMd ? totalStickyDuration : totalScrollDuration;

      new ScrollMagic.Scene({
        triggerElement: stickyElem,
        duration: totalDuration,
        triggerHook: 0,
      })
        .setPin(headerEle)
        // .addIndicators({ name: 'Sticky Header' })
        .addTo(parallaxModuleImage);

      // Image Animation
      allImages.forEach((image, imgIndex) => {
        const moveY = [2, 3, 4, 7].includes(imgIndex) ? '-20%' : '20%';
        const imageAnimationTween = gsap.to(image, { y: moveY, ease: 'none', paused: true });

        new ScrollMagic.Scene({
          triggerElement: parentElem,
          triggerHook: 0,
          duration: totalScrollDuration,
        })
          .setTween(imageAnimationTween)
          .addTo(parallaxModuleImage);
      });
    });
  };

  initParallaxScrollMagic();
}
